<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="ip_primario" class="col-sm-2 control-label">TEMPO PARADO (seg):</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.tempo_parado" class="form-control input-sm" id="ip_primario">
            </div>
            <label for="porta_primario" class="col-sm-2 control-label">TEMPO DIRIGINDO (seg):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.tempo_dirigindo"  class="form-control" id="porta_primario" >
            </div>
        </div>
        <div class="form-group">
            <label for="ip_secundario" class="col-sm-2 control-label">TEMPO EM EMERGÊNCIA:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.tempo_emergencia" class="form-control" id="ip_secundario">
            </div>
            <label for="porta_secundario" class="col-sm-2 control-label">TENTATIVAS EM EMERGÊNCIA:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.num_envio_emergencia"  class="form-control" id="porta_secundario" >
            </div>
        </div>
        <div class="form-group">
            <label for="autenticacao" class="col-sm-2 control-label">DIST. S/ TRANSMISSÃO:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.distancia_intervalo"  class="form-control" id="autenticacao" >
            </div>
            <label for="apn" class="col-sm-2 control-label">KEEP ALIVE</label>
            <div class="col-sm-4">
                <input type="number" v-model.number="config.tempo_keep_alive"  class="form-control" id="apn" >
            </div>
        </div>
        <!--
        <div class="form-group">
            <label for="usuario" class="col-sm-2 control-label">TEMPO DIRIGINDO POR SMS:</label>
            <div class="col-sm-3">
                <input type="text" v-model.number="config.tempo_andando_sms" class="form-control" id="usuario">
            </div>
            <label for="senha" class="col-sm-2 control-label">TEMPO PARADO POR SMS</label>
            <div class="col-sm-3">
                <input type="text" v-model.number="config.tempo_parado_sms"  class="form-control" id="senha" >
            </div>
        </div>
        <div class="form-group">
            <label for="pin" class="col-sm-2 control-label">QTDE POR SMS:</label>
            <div class="col-sm-3">
                <input type="text" v-model="config.pin" class="form-control" id="pin">
            </div>
        </div>
        -->
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-4">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>

            <div class="col-sm-4">

            </div>
            <div class="col-sm-2">

                <div class="dropup">
                    <button class="btn btn-xs btn-block btn-default dropdown-toggle" type="button" id="dropdownMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-list-alt"></i> AÇÕES
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuList">
                        <li>
                            <button @click="sendAll()" type="button" class="btn btn-xs btn-success">
                                <i class="fa fa-save"></i> ENVIAR COMANDOS PARA TODOS
                            </button>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </form>
</template>
<script>
    import {Suntech} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "TempoSuntech",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendTempos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },
            sendAll () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração para todos?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendTemposAll(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
